<template>
    <div
        v-if="project"
        class="d-flex align-center"
    >
        <icon icon="ClipboardList" :color="project.color" />
        <div
            style="white-space: nowrap"
            class="ml-1"
            :class="dense ? 'caption' : 'body-2'"
        >
            {{ project.name }}
        </div>
    </div>
</template>

<script>
export default {
    name: "RichDataTableProject",
    props: {
        project: {
            type: Object,
            default: null
        },
        dense: {
            type: Boolean,
            default: false
        }
    }
};
</script>
